import React from 'react';

import { useDispatch } from 'react-redux';

import { closestCenter, DndContext, type DragEndEvent, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import {
  changeTasksOrder,
  setSelectedFormTasksTableRow,
} from 'src/store/adminConfigPageSlice/regionTasksPageSlice/regionTasksPageSlice';
import { useAppSelector } from 'src/store/store';

import SortableRegionTaskRow from './sortableRegionTaskRow';

// **** Components **** //

/**
 * Default component.
 */
const SortableRegionTaskList = () => {
  const { taskFormTableData } = useAppSelector((state) => state.regionTasksConfigPage);
  const dispatch = useDispatch();
  const sensors = useSensors(useSensor(PointerSensor));

  const handleDragEnd = (event: DragEndEvent) => {
    if (!event.over) return;
    const target = event.activatorEvent.target as HTMLElement;
    const oldIndex = event.active.data.current?.sortable.index;
    const newIndex = event.over?.data.current?.sortable.index;
    // If the target is a button or is within a button, we don't want to move it,
    // and open the modal instead.
    if (!target.closest('button')) {
      // Make sure a full drag events happens.
      if (String(oldIndex) !== String(newIndex)) {
        dispatch(changeTasksOrder({ old: oldIndex, new: newIndex }));
      }
    } else {
      dispatch(setSelectedFormTasksTableRow(taskFormTableData[oldIndex]));
    }
  };

  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <SortableContext items={taskFormTableData.map((item) => item.entityId)} strategy={verticalListSortingStrategy}>
        {taskFormTableData.map((task) => (
          <SortableRegionTaskRow row={task} key={task.entityId} />
        ))}
      </SortableContext>
    </DndContext>
  );
};

// **** Export **** //

export default SortableRegionTaskList;
